$(document).ready(function() {
	//if ($("#home_slider").length){
		//setTimeout(function(){	
			$("#home_slider").owlCarousel({
				loop:true,
				autoplay:true,               
				autoplayTimeout:5000,
				margin:40,
                autoplayHoverPause:true,             
                rewind:true,
				nav: true,
				dots:true,
				navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>'],
				responsiveClass:true,
				responsive:{
					0:{

						items:1,										
					},
					768:{

						items:1,
					},
					1025:{ 
						items:1,						
				
					}
				}		
			});
//});
   // }
/*
  $('.one-time').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
}); */

  $('.home_responsive_slide').slick({
  dots: true,
  infinite: true,
  dots: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
         dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
}); 
